angular = require('angular')

app = angular.module('workflow.app')
app.directive('blurOnEnter', () ->
  return {
    link: (scope, element, attrs) ->
      element.bind("keydown keypress", (event) ->
        if event.which == 13
          element[0].blur()

          event.preventDefault()
      )
  }
)
